export const CONFIG = {
	// FRONTEND_URL: "http://localhost:3000",
	FRONTEND_URL: "https://bb1.bilahbaja.net",
	// FRONTEND_URL: "https://dev2.bilahbaja.net",
	// BACKEND_URL: "http://192.168.1.62/sparepart-backend/public/api",
	BACKEND_URL: "https://bb2.bilahbaja.net",
	// BACKEND_URL: "https://dev1.bilahbaja.net",
};
